import { CircleCheckBig } from 'lucide-react'
import { useState } from 'react'
import { Link } from 'react-router'

import Button from '@/elements/Button'
import Pill from '@/elements/Pill'
import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import Timestamp from '@/elements/Timestamp'
import useNotifications from '@/hooks/useNotifications'
import useBreakpoints from '@/hooks/useBreakpoints'
import type { NotificationResponse } from '@/api/types/Notification'

function NotificationCard({
  notification,
  markAsRead,
}: {
  notification: NotificationResponse,
  markAsRead: () => void,
}) {
  const [hovered, setHovered] = useState(false)
  const { getNotificationTypeName, notificationMessage } = useNotifications(notification)
  const { isMobile } = useBreakpoints()

  return (
    <Link
      to={`/alert/${notification.data.id}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={!notification.readAt ? markAsRead : undefined}
      style={{ width: '100%' }}
    >
      <Flex
        inline
        wfull
        hfull
        gap={3}
        px={2}
        py={3}
        radius='small'
        color={hovered ? 'gray-light-60' : 'white'}
        style={{ transition: 'all .3s ease-in-out' }}
      >
        <Flex
          color={notification.readAt ? 'gray-light-20' : 'blue'}
          mt={2}
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
          }}
        />
        <Flex gap={3} grow>
          <Flex inline={!isMobile} align={!isMobile ? 'center' : undefined} gap={2} wfull wrap>
            {notification.readAt ? (
              <Pill variant='neutral'>
                {getNotificationTypeName(notification.type)}
              </Pill>
            ) : (
              <Pill variant='notification-type' status={notification.type}>
                {getNotificationTypeName(notification.type)}
              </Pill>
            )}
            <Timestamp from={notification.createdAt || ''} />
          </Flex>
          <Flex gap={2}>
            <Text color={notification.readAt ? 'black-light-40' : 'black'}>
              {notificationMessage}
            </Text>
            {notification.data.comment?.content && (
              <Text color='black-light-40' variant='textblock'>
                {notification.data.comment.content}
              </Text>
            )}
          </Flex>
        </Flex>
        {!notification.readAt && (
          <Flex hfull justify='center' pr={2}>
            <Button variant='iconBtn' onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              markAsRead()
            }}>
              <CircleCheckBig size={18} style={{ minWidth: 18 }} />
            </Button>
          </Flex>
        )}
      </Flex>
    </Link>
  )
}

export default NotificationCard
